import DarkMode from '@assets/icons/dark-mode.svg'
import { Icon } from './Icon'

export const DarkModeIcon = Icon(DarkMode)
